import React from 'react';

import ErrorBoundaryIcon from '../../assets/images/error-boundary-icon.svg';
import Button from '../Button';

import ErrorStyles from './SomethingWentWrong.module.scss';

const SomethingWentWrong = () => {
  return (
    <div className={ErrorStyles.somethingWrong}>
      <div className={ErrorStyles.somethingWrong__image}>
        <img src={ErrorBoundaryIcon} alt="Something went wrong" width="100%" height="100%" />
      </div>

      <div className={ErrorStyles.somethingWrong__info}>
        <h3 className={ErrorStyles.somethingWrong__header}>Ooops...</h3>

        <p className={ErrorStyles.somethingWrong__subheader}>Something went wrong</p>

        <p className={ErrorStyles.somethingWrong__message}>
          Sorry, the content you’re looking for doesn’t exist. Either it was removed, or you
          mistyped the link.
        </p>

        <Button type="button" title="Reload" onPress={() => window.location.reload()} />
      </div>
    </div>
  );
};

export default SomethingWentWrong;
